import Vue from 'vue';
export default Vue.extend({
    name: 'confirmActionPopupChunk',
    props: {
        slotData: {
            required: true
        }
    },
    data() {
        return {
            isValid: false,
            fields: {
                secretCode: {
                    type: 'password',
                    value: '',
                    rules: [
                        (v) => Boolean(v.length) || this.$t('whitelistsPage.errors.fieldIsRequired')
                    ]
                }
            }
        };
    },
    methods: {
        toggleSecretAppear() {
            const vm = this;
            vm.fields.secretCode.type = vm.fields.secretCode.type === 'password' ? 'text' : 'password';
        }
    }
});
